<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles customerManagement_leader">
            <van-loading
                class="pageLogin"
                v-if="loading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title=""
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
                <template #title>
                    <div
                        :class="{'active': listType == 'zkh'}"
                        @click="listSwitch('zkh')"
                    >
                        客户{{ customersNumber.nub }}个
                    </div>
                    <div
                        :class="{'active': listType == 'fwkh'}"
                        @click="listSwitch('fwkh', servingCustomers.type)"
                    >
                        服务客户{{ servingCustomers.nub }}个
                    </div>
                    <div
                        :class="{'active': listType == 'qzkh'}"
                        @click="listSwitch('qzkh', leadsCustomers.type)"
                    >
                        潜在客户{{ leadsCustomers.nub }}个
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="queryCriteria" placeholder="请输入客户名称搜索" @change="search"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item, index) in customerData">
                                <li :key="index">
                                    <div class="engineeringInfo" @click="customerEdit(item)">
                                        <h4 class="engineeringInfo_header">
                                            <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                            <span class="headerName">{{ item.name }}</span>
                                        </h4>
                                        <span class="state">{{ item.type_name }}</span>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                <span>统一信用代码：{{ item.license_code }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_5.png" alt="">
                                                <span>客户性质：{{ item.nature_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_40.png" alt="">
                                                <span>客户等级：{{ item.level_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_3.png" alt="">
                                                <span>关联客户：{{ item.rel_client_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_3.png" alt="">
                                                <span>登记人：{{ item.creator }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>登记时间：{{ item.created }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="btn-con">
                                        <div class="btn-item" @click="toEngineerInfo(item)">
                                            <span class="btn-span">工程信息</span>
                                        </div>
                                        <div class="btn-item" @click="toContractInfo(item)">
                                            <span class="btn-span">合同信息</span>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>
<script>

export default {
    // 客户管理
    name: 'customer-management-leader',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'customer-management-leader');
        }
        next();
    },
    props: {},
    data() {
        return {
            credit: 0,
            // 录入上拉菜单客户类型数据
            addToData: [],
            // 客户性质选择数据
            customerNatureData: [],
            // 客户等级选择数据
            customerLevelData: [],
            // 上拉索引
            count: 0,
            // 列表总条数
            total: 0,
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 页面login状态
            loading: false,
            // 客户列表数据
            customerData: [],
            // 查询条件
            queryCriteria: '',
            // 当前打开列表类型，zkh客户数，fwkh服务客户，qzkh// 潜在客户
            listType: 'zkh',
            // 客户数
            customersNumber: {
                type: '',
                nub: 0,
            },
            // 服务客户
            servingCustomers: {
                type: '002-FL0-02',
                nub: 0,
            },
            // 潜在客户
            leadsCustomers: {
                type: '002-FL0-01',
                nub: 0,
            },
            // 选择客户类型编码
            customersType: '',
        };
    },
    computed: {},
    watch: {
        customerData(newVal) {
            newVal.forEach(item => {
                if (item.type_name === '' || item.type_name === null) {
                    this.addToData.forEach(k => {
                        if (k.code === item.type) {
                            item.type_name = k.name;
                        }
                    });
                }
                if (item.level_name === '' || item.level_name === null) {
                    this.customerLevelData.forEach(k => {
                        if (k.code === item.level) {
                            item.level_name = k.name;
                        }
                    });
                }
                if (item.nature_name === '' || item.nature_name === null) {
                    this.customerNatureData.forEach(k => {
                        if (k.code === item.nature) {
                            item.nature_name = k.name;
                        }
                    });
                }
            });
        },
    },
    created() {
        // 客户类型
        this.getbycode('addToData', '002-FL0');
        // 客户性质选择数据赋值
        this.getbycode('customerNatureData', '002-XZ0');
        // 客户等级选择数据赋值
        this.getbycode('customerLevelData', '002-DJ0');
        // 获取用户数量
        this.getCustomersNumber();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 下拉刷新
        onRefresh() {
            this.count = 1;
            this.finished = false;
            this.customerData = [];
            this.gitCustomerData();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            // 拉取客户列表数据
            this.gitCustomerData();
        },
        // 搜索
        search() {
            this.count = 1;
            this.customerData = [];
            this.finished = false;
            this.gitCustomerData();
        },
        // 通过code拉取字典信息
        async getbycode(type, parentCode) {
            await this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=' + parentCode)
                .then(res => {
                    this[type] = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 客户信息编辑
        customerEdit(data) {
            this.$router.isBack = 2;
            this.$router.push({ path: '/customerEntry_leader', query: { data: data } });
        },
        // 客户类型切换
        listSwitch(obj, type) {
            this.count = 1;
            this.customerData = [];
            this.finished = false;
            this.listType = obj;
            if (type) {
                this.customersType = type;
            } else {
                this.customersType = '';
            }
            this.gitCustomerData();
        },
        // 拉取客户列表数据
        gitCustomerData() {
            // 请求列表数据地址
            let getUrl = '';
            if (this.queryCriteria && this.queryCriteria !== '') {
                // eslint-disable-next-line max-len
                getUrl = `/interfaceApi/sale/client_manager/get_clients_leader_page?Keywords=${this.queryCriteria}&client_type=${this.customersType}&pageindex=${this.count}&pageSize=3`;
            } else {
                // eslint-disable-next-line max-len
                getUrl = `/interfaceApi/sale/client_manager/get_clients_leader_page?client_type=${this.customersType}&pageindex=${this.count}&pageSize=3`;
            }
            this.$axios
                .get(getUrl)
                .then(res => {
                    this.total = res.total;
                    if (this.customerData.length < 1) {
                        this.customerData = res.rows;
                    } else {
                        this.customerData.push(...res.rows);
                    }
                    if (this.customerData.length >= this.total) {
                        this.finished = true;
                    }
                    this.isUpLoading = false;
                    this.isLoading = false;
                }).catch(error => {
                    this.loading = false;
                    this.$dialog({ message: error });
                });
        },
        // 获取用户数量
        getCustomersNumber() {
            this.$axios
                .get('/interfaceApi/sale/client_manager/get_type_client_count?isleader=1')
                .then(res => {
                    if (res) {
                        let zkh = 0;
                        res.forEach(item => {
                            zkh += Number(item.num);
                            // 潜在客户
                            if (item.type === '002-FL0-01') {
                                this.leadsCustomers.nub = item.num;
                                // 服务客户
                            } else if (item.type === '002-FL0-02') {
                                this.servingCustomers.nub = item.num;
                            }
                        });
                        this.customersNumber.nub = zkh;
                    }
                }).catch(error => {
                    this.$dialog({ message: error });
                });
        },
        // 跳转到工程信息
        toEngineerInfo(item) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/engineerList',
                query: {
                    client_id: item.id,
                    backUrl: '/customerManagement_leader',
                },
            });
        },
        // 跳转到合同信息
        toContractInfo(item) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/contractList',
                query: {
                    client_id: item.id,
                    backUrl: '/customerManagement_leader',
                },
            });
        },
    },
};
</script>
<style lang="stylus">
.customerManagement_leader
    height 100%
    .van-nav-bar
        .van-nav-bar__title
            width calc(100% - 70rpx)
            max-width 100%
            margin-left 70rpx
            display:flex;
            div
                flex:1;
                text-align:center;
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 16rpx
                    color #fff
    section
        height calc(100% - 44rpx)
        .operate
            height 45rpx
            position relative
            button
                width 50%
                height 45rpx
                font-size 14rpx
                line-height 45rpx
                color #333333
                border none
                background #fff
            &:after
                content ''
                border-left 2px solid #F0F0F0
                height 15rpx
                position absolute
                left 50%
                top 15rpx
        .van-pull-refresh
            height calc(100% - 45rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                background #F0F0F0
                padding 15rpx
                li
                    .state
                        position absolute
                        top 15rpx
                        right 15rpx
                        font-size 12rpx
                        color #D60110
                        font-weight 600
        .contactInfo
            h5,p
                font-size 16rpx
                line-height 45rpx
                text-align center
            h5
                color #333333
                background #F8F8F8
            p
                color #0189FC
                border-bottom 1px solid  #F0F0F0

</style>
